import { useEffect, useState } from "react";
import { API_DOMAIN } from "config";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_DOMAIN}/admin/summary`)
      .then((r) => r.json())
      .then(setStats)
      .catch(console.error);
  }, []);

  if (!stats) {
    return (
      <div className="flex items-center justify-center h-[60vh] text-slate-400">
        טוען נתוני מערכת…
      </div>
    );
  }

  const cards = [
    {
      label: "ספקים",
      value: stats.providers,
      accent: "from-sky-500 to-sky-600",
      icon: "🏭",
    },
    {
      label: "סוחרים",
      value: stats.dealers,
      accent: "from-amber-500 to-amber-600",
      icon: "🚗",
    },
    {
      label: "רכבים פעילים",
      value: stats.active_cars,
      accent: "from-emerald-500 to-emerald-600",
      icon: "📊",
    },
    {
      label: "הצעות ממתינות",
      value: stats.pending_offers,
      accent: "from-rose-500 to-rose-600",
      icon: "⏳",
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <header className="flex flex-col gap-1 text-right">
        <h1 className="text-2xl font-semibold text-slate-50">
          דשבורד מנהל
        </h1>
        <p className="text-sm text-slate-400">
          תמונת מצב של המערכת – משתמשים, רכבים והצעות.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div
            key={c.label}
            className="relative overflow-hidden rounded-2xl bg-slate-950 border border-slate-800 shadow-xl p-4 flex flex-col items-end"
          >
            <div
              className={`absolute inset-y-0 left-[-40%] w-2/3 bg-gradient-to-br ${c.accent} opacity-20 blur-3xl`}
            />
            <div className="relative flex items-center justify-between w-full">
              <div className="flex flex-col items-end gap-1">
                <span className="text-xs text-slate-400">{c.label}</span>
                <span className="text-2xl font-bold text-slate-50">
                  {c.value ?? 0}
                </span>
              </div>
              <div className="h-10 w-10 rounded-2xl bg-slate-900/60 flex items-center justify-center text-xl">
                {c.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
